var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{ref:"dialog",attrs:{"destroy-on-close":true,"title":_vm.title,"visible":_vm.dialogVisible,"width":_vm.width,"before-close":_vm.close},on:{"opened":_vm.opened,"close":_vm.cancel}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }